import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import security from 'stores/security';
import ui from 'stores/ui';
import list1 from './images/list-1.jpg';
import list2 from './images/list-2.jpg';
import list3 from './images/list-3.jpg';
import list4 from './images/list-4.jpg';
import './style.scss';

const picList = [
    {
        id: 1,
        img: list1,
        desc: 'Orders placed by registered representatives on behalf of customers'
    },
    {
        id: 2,
        img: list2,
        desc: 'Orders executed during the pre- and post-market periods'
    },
    {
        id: 3,
        img: list3,
        desc: 'Orders for securities traded in the OTC market'
    },
    {
        id: 4,
        img: list4,
        desc: 'Orders for stocks that trade at less than $1'
    }
];

security.getDownloadUrl();

class GP2T extends Component<{}> {
    /**
     *  如果路由带有jump参数，表示需要跳转到交易页
     */
    componentDidMount() {
        if (window.location.href.indexOf('jump') > -1) {
            const newUrl = window.location.href.replace(/jump=true/g, '');

            window.history.replaceState('', '', newUrl);
            security.goToTrade();
        }
    }

    render() {
        return (
            <div className="page-paid">
                <Helmet>
                    <title>Get Paid to Trade</title>
                    <meta
                        name="description"
                        content="Trade 1,000 shares or more to get a credit of $1 to your TradeUP account."
                    />
                </Helmet>
                <header className="paid-header">
                    <div className="paid-wrapper">
                        <h1 className="paid-title">Get Paid to Trade</h1>
                        <p className="paid-desc">
                            Trade 1,000 shares or more to get a credit of <strong>$1 to your TradeUP account.</strong>
                        </p>
                        <a
                            className="paid-btn border-1px"
                            target="_blank"
                            href="https://www.tradeup.com/statement/USA-GP2Tterms">
                            Terms and Conditions
                        </a>
                    </div>
                </header>
                <section className="paid-intro">
                    <h2 className="intro-title">How It Works</h2>
                    <div className="intro-step">
                        <div className="step-1">
                            <span className="num1"></span>
                            <span className="text">Enter a Qualifying Order for 1,000 Shares or More.</span>
                        </div>
                        <div className="step-2">
                            <span className="num2"></span>
                            <span className="text">Get Paid to Trade</span>
                        </div>
                    </div>
                    {ui.isMobile ? (
                        <Button className="intro-start" onClick={security.goToTrade}>
                            Start Trading
                        </Button>
                    ) : (
                        <a target="_blank" href="https://web.tradeup.com/quote/AAPL/chart" className="intro-start">
                            Start Trading
                        </a>
                    )}
                </section>
                <section className="paid-content">
                    <h3 className="content-title">Which Orders Do Not Qualify?</h3>
                    <div className="content-list">
                        {picList.map(i => (
                            <div className="content-item" key={i.id}>
                                <img src={i.img} alt="content-pic" className="content-pic" />
                                <p className="content-desc">{i.desc}</p>
                                <div className="content-line"></div>
                            </div>
                        ))}
                    </div>
                </section>
                <section className="paid-case">
                    <h3 className="case-title">Example</h3>
                    <div className="case-content">
                        <h4 className="case-bg">Case 1</h4>
                        <p className="case-desc">
                            Suppose you want to buy 1000 shares of XYZ stock. To enter a qualifying order and{' '}
                            <strong className="strong">Get Paid to Trade</strong>, you would simply enter an order to
                            buy 1000 shares of XYZ. Upon execution, you will receive 1000 shares XYZ at $0 commission
                            and a $1 credit to your account. That’s it!
                        </p>
                        <h4 className="case-bg">Case 2</h4>
                        <p className="case-desc">
                            Suppose you want to buy 10 options contracts. To enter a qualifying order and{' '}
                            <strong className="strong">Get Paid to Trade</strong>, you would simply enter an order to
                            buy 10 options contracts. Upon execution, you will receive 10 options contracts and a $1 to
                            your account.
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}

export default GP2T;
